module.exports = __webpack_public_path__ + "img/step4-c.3f6f7253.png";